import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import SEO, { pageSEO } from "../components/seo.component";
import { Link } from "react-router-dom";
import ContactForm from "./contactForm.component";
import Contact from "./contact.component";
import servicesBg from "../assets/images/photo-1600210491892-03d54c0aaf87.jfif";

export default function BuyerGuide() {
  const [open, setOpen] = useState(
    new Array(constants.BUYING_GUIDE.length).fill(false)
  );

  const seoConfig = pageSEO.buyerGuide();

  return (
    <>
      <SEO {...seoConfig} />
      <div className="w-full text-gray-800 pt-[180px]">

        {/* HERO SECTION */}
        <section className="py-20 text-center max-w-7xl mx-auto px-6">
          <h1 className="text-5xl font-semibold mb-4">Buying with Alex</h1>
          <div className="w-32 h-[2px] bg-logo-main my-3 mx-auto" />
          <h3 className="text-2xl text-black my-6 font-light">Your path to homeownership</h3>
          <p className="text-black font-light leading-relaxed">
            Buying a home is a big decision, and I can help guide you through the process. As someone with experience in the GTA area, a strong track record of successful home sales, and a reputation for excellent customer service. When you make the important decision to buy a home, I am committed to going the extra mile to ensure that all of your needs are successfully met in a professional and honest manner.
          </p>
        </section>

        {/* SERVICE & COMMITMENT */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 mx-auto items-stretch">
          <div className="w-full lg:w-[70%] lg:ml-auto py-10 lg:py-8 px-6 lg:px-0 order-2 lg:order-1">
            <h2 className="text-4xl font-semibold mb-2">Service & Commitment</h2>
            <h3 className="text-xl text-black font-light mb-4">What to expect when buying with me</h3>

            <ul className="space-y-4 list-disc pl-5 text-black font-semibold">
              <li>Access to listings: I have access to a wealth of listings, including homes that may not be publicly listed, giving you more options to choose from.</li>
              <li>Expertise: I have a deep understanding of the market and can provide valuable insights and advice on factors like home values, negotiation strategies, and closing costs.</li>
              <li>Negotiation skills: I am an experienced negotiator and can help you get the best deal on your new home.</li>
              <li>Handling paperwork: The home-buying process involves a lot of paperwork, and I can help you navigate it all, from the offer to closing.
              </li>
              <li>Stress relief: Buying a home can be stressful, but I can take some of the burden off by handling the logistics and communicating with other parties involved in the transaction.</li>
            </ul>

            <div className="my-10 flex flex-col md:flex-row gap-4 ">
              <Link
                to={"/listings"}
                className="whitespace-nowrap text-lg uppercase tracking-wider w-fit border-2 border-logo-main hover:bg-logo-third hover:border-transparent hover:text-white hover:scale-110 duration-500 ease-in-out
                                  px-5 md:px-9 py-[7px] md:py-[12px] text-logo-second font-semibold transition-all transform"
              >
                View my listings
              </Link>
              <Link
                to={"/contact"}
                className="whitespace-nowrap text-lg uppercase tracking-wider w-fit border-2 border-logo-main hover:bg-logo-third hover:border-transparent hover:text-white hover:scale-110 duration-500 ease-in-out
                                  px-5 md:px-9 py-[7px] md:py-[12px] text-logo-second font-semibold transition-all transform"
              >
                Contact me today
              </Link>
            </div>
          </div>

          <img
            src={servicesBg}
            alt="real estate"
            className="object-cover lg:aspect-[4/3] w-full order-1 lg:order-2"
          />
        </section>

        {/* HOW IT WORKS */}
        <section className="bg-logo-second text-white py-20 px-6">
          <div className="max-w-7xl mx-auto text-center mb-10 space-y-6">
            <h2 className="text-5xl font-semibold">How it works</h2>
            <p className="text-2xl">Guiding you the whole way!</p>
            <p>As your guide to find your dream home, I will assist you in identifying the perfect property at the right price. Along with drafting a contract, presenting your offer, and setting you up on auto notifications, so you will be among the first to receive updates on new listings. You'll be in a new home in no time!</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-7xl mx-auto">
            {[
              {
                title: "The Meet",
                text: "We'll meet and discuss the type of home you are looking for, including style, budget, and location. Well go over any expectations and questions you may have and review any buyer's agent agreements"
              },
              {
                title: "The Fun Part",
                text: "We'll start checking out places that you can see yourself living in, book private showings or visit some open houses! As we get a feel for different places we can adjust your needs and wants list accordingly. I'll also set you up with automatic updates of new listings that hit the market that match what you are looking for."
              },
              {
                title: "The Sale",
                text: "After finding the right home it's time to discuss the terms of your offer. I will prepare the necessary paperwork and present the offer to the sellers and negotiate any counteroffers on your behalf. My goal is to get you into your new home with a fair price in a stress free and efficient manner."
              }
            ].map((item, i) => (
              <div key={i} className="text-white p-6 rounded-xl border border-logo-main">
                <h3 className="text-3xl font-semibold mb-4">{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* RESOURCES */}
        <section className="py-20 px-6 max-w-7xl mx-auto">
          <div className="max-w-7xl mx-auto text-center mb-10 space-y-6">
            <h2 className="text-5xl font-semibold text-center">
              Helpful Buying Resources
            </h2>
            <p className="text-2xl font-light">Tips and Things To Watch For</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {constants.BUYING_RESOURCES.map((r, i) => (
              <div key={i} className="border overflow-hidden">
                <img src={r.img} alt={r.title} className="h-64 w-full object-cover overflow-hidden" />
                <div className="p-4 flex flex-col justify-between lg:h-[250px]">
                  <div className="space-y-5 mb-10 lg:mb-0">
                    <h3 className="font-semibold text-2xl">{r.title}</h3>
                    <p className="text-black font-light">{r.desc}</p>
                  </div>

                  <a className="group uppercase tracking-wider w-fit border-2 border-logo-main hover:bg-logo-third hover:border-transparent hover:text-white hover:scale-110 duration-500 ease-in-out
                  px-3 lg:px-9 py-[7px] lg:py-[12px] text-logo-second font-semibold transition-all transform inline-block"
                    href={r.url}
                    download={true}
                  >
                    Download
                    <FontAwesomeIcon icon={faAngleRight} className="ml-3 text-lg text-logo-main group-hover:text-white transition-colors duration-300" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section >

        {/* CALL TO ACTION */}
        < section className="bg-logo-second text-white py-20 text-center px-6" >
          <div className="max-w-5xl mx-auto text-center space-y-6">
            <h2 className="text-4xl font-semibold">Ready to make a move?</h2>
            <p className="mt-2 mb-6 text-2xl">I look forward to hearing from you!</p>
            <p className="text-lg font-light">Buying a home can be an exciting and challenging process, but with the right team and preparation, it can also be a smooth and successful experience. Contact me today to learn more about how I can help you find your dream home!</p>
            <a href="#contact" className="uppercase tracking-wider border border-white hover:bg-logo-third hover:border-transparent text-white hover:scale-110 duration-500 ease-in-out px-5 md:px-9 py-[7px] md:py-[12px] text-logo-second font-semibold transition-all transform inline-block">
              Let’s Connect
            </a>

            <div className="flex gap-x-5 justify-center">
              {Object.entries(constants.SOCIALS)?.map(([k, v]) => (
                <a href={constants.SOCIALS[k]}>
                  <FontAwesomeIcon
                    className="fa-xl text-logo-main"
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
          </div>
        </section >

        {/* CONTACT FORM */}
        < ContactForm />

        <Contact />

      </div >
    </>
  );
}
